<script setup>
import { ref } from 'vue';
import { versionVue } from '@/modules/configuracoes/version/store';
import LiberacaoPagamentoView from '@/modules/configuracoes/keys/views/LiberacaoPagamentoView.vue';
import { serialPrincipal } from '@/modules/configuracoes/keys/store';

const liberacaoPagamentoModal = ref();

function abrirPagamentoLicenca() {
  liberacaoPagamentoModal.value.fillLiberacao();
  liberacaoPagamentoModal.value.openClose = !liberacaoPagamentoModal.value.openClose;
}
</script>

<template>
  <footer class="footer footer-static footer-light">
    <p class="clearfix mb-0">
      <span class="float-md-start d-block d-md-inline-block mt-25 me-2"><i class="fa-sharp fa-regular fa-id-card me-1 cursor-pointer" style="color: #949494;" @click="abrirPagamentoLicenca()"></i>{{ serialPrincipal }}</span>
      <span class="float-md-start d-block d-md-inline-block mt-25">© {{ new Date().getFullYear() }}<a class="ms-25" href="https://vrtech.app/" target="_blank">VR Tech</a></span>
      <span class="float-md-start d-none d-md-block mt-25 ms-1">v.{{ versionVue }}</span>
      <span class="float-md-end d-none d-md-block">made in <img src="/assets/img/germanyflag.png" alt="Bandeira Alemanha" /> Düsseldorf with <font-awesome-icon :icon="['fas', 'heart']" /></span>
    </p>
  </footer>
  <LiberacaoPagamentoView ref="liberacaoPagamentoModal" :visible="false" />
</template>
